import { render } from "./NonEditBasicDetails.vue?vue&type=template&id=0c56a51d"
import script from "./NonEditBasicDetails.vue?vue&type=script&lang=js"
export * from "./NonEditBasicDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__